const sessionsColumnData = [
  {
    Header: 'Id',
    accessor: 'id'
  },
  // {
  //   Header: 'Player',
  //   accessor: 'player'
  // },
  {
    Header: 'Player Nickname',
    accessor: 'playerNickname',
    Cell: ({ value }) => {
      return value ? value : '-';
    }
  },
  {
    Header: 'Player username',
    accessor: 'playerUsername'
  },
  {
    Header: 'Game mode',
    accessor: 'gameMode'
  },
  {
    Header: 'Game',
    accessor: 'game'
  },
  {
    Header: 'Client',
    accessor: 'clientName',
    Cell: ({ value }) => {
      return value ? value : '-';
    }
  },
  {
    Header: 'Bet range',
    accessor: 'betRange',
    Cell: ({ value }) => {
      if (!value) return '-';
      return value?.minBet !== null && value?.maxBet !== null && (value?.minBet !== '0' || value?.maxBet !== '0')
        ? `${value?.minBet} - ${value?.maxBet}`
        : value?.singleBet !== null
        ? value.singleBet
        : '-';
    }
  },
  {
    Header: 'Duration',
    accessor: 'duration'
  },
  {
    Header: 'IP',
    accessor: 'ip',
    Cell: ({ value }) => {
      return value ? value : '-';
    }
  },
  {
    Header: 'Session Date',
    accessor: 'sessionDate'
  },
  {
    Header: 'Country',
    accessor: 'sessionCountry',
    Cell: ({ value }) => {
      return value ? value : '-';
    }
  },
  {
    Header: 'Metric Count',
    accessor: 'metricCount'
  }
];
export default sessionsColumnData;
